import React from "react";
import PageHeading from "../utils/PageHeading";
import classes from "./Cart.module.css";
import useShopStore from "../store/useShopStore";
import { useEffect, useState } from "react";
import CartRow from "../components/CartRow";
import ButtonLink from "../utils/ButtonLink";
import EmptyCart from "../components/EmptyCart";
import Spinner from "../utils/Spinner";
import EmptyCartButton from "../components/EmptyCartButton";

export default function Cart(props) {
  const [loading, setLoading] = useState(false);
  const { showCart, cart } = useShopStore((state) => state);

  useEffect(() => {
    setLoading(true);
    showCart();
    setLoading(false);
  }, [showCart]);

  return (
    <div>
      <PageHeading>Cart</PageHeading>
      {loading && <Spinner />}
      {cart?.products.length > 0 && (
        <div className={classes.cartMain}>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <EmptyCartButton />
          </div>

          <div className={classes.cartListContainer}>
            {cart.products?.map((product) => {
              return (
                <CartRow
                  image={product.productId.image}
                  qty={product.quantity}
                  price={product.priceTotal}
                  name={product.productId.name}
                  id={product.productId._id}
                  key={product.productId._id}
                />
              );
            })}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: " 2rem",
              }}
            >
              <div className={classes.actionContainer}>
                <div className={classes.summe}>
                  Summe <span>{cart?.totalPrice} EUR</span>
                </div>
                <div>
                  <ButtonLink
                    className={classes.buttonLink}
                    style={{
                      width: "100%",
                      display: "block",
                      textAlign: "center",
                    }}
                    to="/checkout"
                  >
                    Checkout
                  </ButtonLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {cart?.products.length === 0 && <EmptyCart>See Products</EmptyCart>}
    </div>
  );
}
